import { faRightLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useEffect, useCallback } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { configState } from "../../context/configState";
import { queryClientState } from "../../context/queryClientState";
import { swapRateState } from "../../context/swapRateState";
import { swapState } from "../../context/swapState";
import { useRoute } from "../../hooks/useRoute";
import { walletState } from "../../context/walletState";

const SwapPriceInfo = ({
  denom1,
  denom2,
}: {
  denom1: string;
  denom2: string;
}) => {
  const { assetsMap } = useRecoilValue(configState);
  const swapRateData = useRecoilValue(swapRateState);
  const { queryClient } = useRecoilValue(queryClientState);
  const { client, address } = useRecoilValue(walletState);
  const { getSwapRate } = useRoute();

  const swapData = useRecoilValue(swapState);
  const setSwapRateData = useSetRecoilState(swapRateState);
  const [rate, setRate] = useState("");
  const [minReceived, setMinReceived] = useState(0);

  const [pImpact, setPImpact] = useState(0.00);

  const [atone, setAtone] = useState(-1);

  useEffect(()=>{
    setMinReceived((100-Number(swapData.slippage))*Number(swapRateData.input2)/100);
    (Number(atone) >= Number(rate)) ?
    setPImpact(100*(Number(atone) - Number(rate))/Number(atone))
    :
    setPImpact(0.00)
  }, [swapData.input1, swapData.slippage, rate]);

  // const legnth = swapRateData.tokenPath.length
  const fetchPrices = useCallback(async () => {
    let newRate: {tokenPath: string[], outputAmount: string};
    if (Number(swapData.input1) > 0)
      newRate = await getSwapRate(denom1, denom2, swapData.input1);
    else newRate = await getSwapRate(denom1, denom2, "1");

    if(atone === -1){
      const temp = await getSwapRate(denom1, denom2, "1");
      setAtone(Number(temp.outputAmount));
    }

    if (newRate === undefined) {
      newRate = {
        tokenPath: [],
        outputAmount: "1",
      };
    }

    const input2 = !Number(swapData.input1)
      ? ""
      : // : (Number(swapData.input1) * Number(newRate)).toString();
        Number(newRate.outputAmount).toString();
    setSwapRateData({
      ...swapRateData,
      input2: input2,
      swapRate: newRate.outputAmount as string,
      tokenPath: newRate.tokenPath,
    });
    const finalrate = Number(swapData.input1)
    ? (Number( newRate.outputAmount) / Number(swapData.input1)).toFixed(5)
    :  swapRateData.swapRate
    setRate(finalrate as string);
    // setRate(newRate.outputAmount as string);
  }, [denom1, denom2, swapData.input1, client]);
  // }, [denom1, denom2, queryClient, swapData]);

  useEffect(() => {
    fetchPrices();
  }, [swapData.input1, denom1, denom2]);
  
  return (
    <div className="swap-priceinfo-container">
      <div className="priceinfo-row">
        <div>Route</div>
        <div className="route-logo">
          {
            swapRateData.tokenPath.length >=2 ?
          (swapRateData.tokenPath).map((den, i)=>{
            return(
              <div key={i+"1"}>
               {i!==0 ? " > ": ""}
              <img src={assetsMap[swapRateData.tokenPath[i]].logo_URIs.png} alt="" height={30} />
              </div>
            )
          })
            :
            <></>
          }
        </div>
      </div>
      <div className="priceinfo-row">
        <div>Minimum Received</div>
        <div>
          <span>{minReceived.toFixed(4)}</span> {denom2}
        </div>
      </div>
      <div className="priceinfo-row">
        <div>Price Impact</div>
        <div className="priceImpact">
          <span>{pImpact.toFixed(2)}%</span>
        </div>
      </div>
      <div className="priceinfo-row">
        <div>Liquidity Provider Fee</div>
        <div>
          <span>{0.3*(Number(swapData.input1))/100}</span> {denom1}
        </div>
      </div>
    </div>
  );
};

export default SwapPriceInfo;
